
import { UPDATE_CUSTOM_USER_DATA,UPDATE_USER_DATA, ADD_BUYER, ADD_CHILD_RECORD, ADD_SELLER, UPDATE_SELLER, USER_LOGOUT} from "actions/actionTypes";
 import _ from "lodash";

import {REHYDRATE} from 'redux-persist/constants'
const initialState = {
    token:'',
    user:  {},
    seller:  {},
    contractor:  {},
    customUserData:{
    },
 }
export default function userReducer(state = initialState, action) {
    switch (action.type) {
        // case ADD_FB_TOKEN :
        //     return {...state, fbtoken: action.data};
        case REHYDRATE: /* this is required to populate reducer state from data saved in persisted store */
            if (_.isUndefined(action.payload.userReducer)){
                return   {
                    token:'',
                    user:  {},
                    seller:  {},
                    contractor:  {},
                    customUserData:{
                    },
                 };
            } else {
                return action.payload.userReducer
            }
        case UPDATE_USER_DATA:
            return {
                ...state,
                user: action.payload.User,
                seller: action.payload.Seller || {},
                contractor: action.payload.Contractor || {},
                 token:action.payload.token ? action.payload.token : state.token,
                customUserData:action.payload.customUserData ? action.payload.customUserData : state.customUserData,

            };
        case UPDATE_CUSTOM_USER_DATA:
            console.log('UPDATE_CUSTOM_USER_DATA',   action.payload  );
            return {
                ...state,
                customUserData:_.extend({},state.customUserData,  action.payload)
            };
        case UPDATE_SELLER:
            return {...state, seller: action.payload};

        case USER_LOGOUT:
            console.log('in USER_LOGOUT ' );
            return initialState;

        default:
            return state;
    }
}